/**
 * Picks which landing-page design this tenant's public site renders, from
 * `theme.templateId` (control DB tenant_theme, set by a super admin on the
 * Branding tab — see backend/control/models.js).
 *
 * "classic" is the original design and the default for every tenant that
 * has never been switched, so this wrapper is a no-op for them.
 */
import React from "react";
import { useSettings } from "../context/SettingsContext";
import LandingPage from "./LandingPage";
import LandingPageSkLodge from "./templates/LandingPageSkLodge";
import LandingPageAsamika from "./templates/LandingPageAsamika";

const TEMPLATES = {
  classic: LandingPage,
  sklodge: LandingPageSkLodge,
  asamika: LandingPageAsamika,
};

export default function LandingPageSwitcher() {
  const { theme } = useSettings();
  const Template = TEMPLATES[theme?.templateId] || LandingPage;
  return <Template />;
}
